"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseHistoryDataStore = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var PromptTypes_1 = require("Prompt/PromptTypes");
var UseHistoryTypes_1 = require("./UseHistoryTypes");
var OnboardingTypes_1 = require("Onboarding/OnboardingTypes");
var InlinePromptsHistoryStore_1 = __importDefault(require("./InlinePromptsHistoryStore"));
var NewFeaturesIndicatorStore_1 = __importDefault(require("./NewFeaturesIndicatorStore"));
var UseHistoryDataStore = (function () {
    function UseHistoryDataStore(_useHistory, useHistoryService) {
        var _this = this;
        var _a;
        this.useHistoryService = useHistoryService;
        this.isDebounced = false;
        this.dismissBlockLibraryExplainer = function () { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.useHistory.dismissedBlockLibraryExplainer) return [3, 2];
                        this.useHistory.dismissedBlockLibraryExplainer = true;
                        return [4, this.useHistoryService.update(this.useHistory)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        this.hasViewed = function (promptId) {
            return _this.getPromptObject(promptId).hasViewed;
        };
        this.hasDismissed = function (promptId) {
            return _this.getPromptObject(promptId).hasDismissed;
        };
        this.hasClicked = function (promptId) {
            return _this.getPromptObject(promptId).hasClicked;
        };
        this.getPromptObject = function (promptId) {
            if (!_this.useHistory.prompts[promptId]) {
                _this.useHistory.prompts[promptId] = emptyPrompt();
            }
            return _this.useHistory.prompts[promptId];
        };
        this.completeRoiCalculatorStep = function (id) {
            _this.useHistory.usageSteps.roiCalculator.push(id);
            _this.useHistoryService.update(_this.useHistory);
        };
        this.completeRoiCalculatorSteps = function (ids) {
            _this.useHistory.usageSteps.roiCalculator = (0, lodash_1.union)(_this.useHistory.usageSteps.roiCalculator, ids);
            _this.useHistoryService.update(_this.useHistory);
        };
        this.silentlySkipAllPrompts = function () {
            Object.values(_this.useHistory.prompts).forEach(function (prompt) {
                prompt.hasDismissed = true;
            });
            _this.useHistoryService.update(_this.useHistory);
        };
        this.useHistory = _useHistory;
        this.useHistory.prompts = this.useHistory.prompts || {
            comments: emptyPrompt(),
            editText: emptyPrompt(),
            styles: emptyPrompt(),
            addBlock: emptyPrompt(),
            share: emptyPrompt(),
            contentLibrary: emptyPrompt(),
        };
        this.useHistory.prompts.editText = this.useHistory.prompts.editText || emptyPrompt();
        this.useHistory.prompts.styles = this.useHistory.prompts.styles || emptyPrompt();
        this.useHistory.prompts.addBlock = this.useHistory.prompts.addBlock || emptyPrompt();
        this.useHistory.prompts.share = this.useHistory.prompts.share || emptyPrompt();
        this.useHistory.prompts.contentLibrary = (_a = this.useHistory.prompts.contentLibrary) !== null && _a !== void 0 ? _a : emptyPrompt();
        this.useHistory.onboarding = this.useHistory.onboarding || emptyOnboarding();
        this.useHistory.onboarding.sequences = this.useHistory.onboarding.sequences || [];
        this.useHistory.usageSteps = this.useHistory.usageSteps || emptyUsageSteps();
        this._inlinePromptsHistoryStore = new InlinePromptsHistoryStore_1.default(this.useHistory, useHistoryService);
        this._newFeaturesIndicator = new NewFeaturesIndicatorStore_1.default(this.useHistory, useHistoryService);
    }
    Object.defineProperty(UseHistoryDataStore.prototype, "inlinePromptsHistoryStore", {
        get: function () {
            return this._inlinePromptsHistoryStore;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "newFeaturesIndicatorStore", {
        get: function () {
            return this._newFeaturesIndicator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowAnyOnboardingPrompts", {
        get: function () {
            return (this.shouldShowEditTextPrompt ||
                this.shouldShowStylePrompt ||
                this.shouldShowAddBlockPrompt ||
                this.shouldShowSharePrompt);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "hasDismissedAnyOnboardingPrompts", {
        get: function () {
            var e_1, _a;
            try {
                for (var onboardingSteps_1 = __values(UseHistoryTypes_1.onboardingSteps), onboardingSteps_1_1 = onboardingSteps_1.next(); !onboardingSteps_1_1.done; onboardingSteps_1_1 = onboardingSteps_1.next()) {
                    var onboardingStep = onboardingSteps_1_1.value;
                    if (this.hasDismissed(onboardingStep)) {
                        return true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (onboardingSteps_1_1 && !onboardingSteps_1_1.done && (_a = onboardingSteps_1.return)) _a.call(onboardingSteps_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowEditTextPrompt", {
        get: function () {
            return this.shouldShow(PromptTypes_1.PromptId.EditText);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowStylePrompt", {
        get: function () {
            return this.shouldShow(PromptTypes_1.PromptId.Styles);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowAddBlockPrompt", {
        get: function () {
            return this.shouldShow(PromptTypes_1.PromptId.AddBlock);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowSharePrompt", {
        get: function () {
            return this.shouldShow(PromptTypes_1.PromptId.Share);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowCommentsPrompt", {
        get: function () {
            return this.shouldShow(PromptTypes_1.PromptId.Comments);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowContentLibraryPrompt", {
        get: function () {
            return this.shouldShow(PromptTypes_1.PromptId.ContentLibrary);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "hasCompletedOnboarding", {
        get: function () {
            var _a = this.useHistory.onboarding.sequences, sequences = _a === void 0 ? [] : _a;
            return !sequences.some(function (s) { return !s.completed; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "hasCompletedCensusCollector", {
        get: function () {
            var _a;
            var sequence = this.findRegisteredSequence(OnboardingTypes_1.SequenceName.CensusCollector);
            return (_a = sequence === null || sequence === void 0 ? void 0 : sequence.completed) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowTemplateExplainer", {
        get: function () {
            return !this.useHistory.shownMarkTemplateExplainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowBlockLibraryExplainer", {
        get: function () {
            return !this.useHistory.dismissedBlockLibraryExplainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UseHistoryDataStore.prototype, "shouldShowTrialConfirmationModal", {
        get: function () {
            var registeredSequence = this.findRegisteredSequence(OnboardingTypes_1.SequenceName.TrialConfirmationModal);
            return !!registeredSequence && !registeredSequence.completed;
        },
        enumerable: false,
        configurable: true
    });
    UseHistoryDataStore.prototype.shouldShow = function (promptId) {
        var e_2, _a, e_3, _b;
        if (this.isDebounced) {
            return false;
        }
        else if (UseHistoryTypes_1.onboardingSteps.includes(promptId)) {
            if (this.hasDismissedAnyOnboardingPrompts) {
                return false;
            }
            try {
                for (var onboardingSteps_2 = __values(UseHistoryTypes_1.onboardingSteps), onboardingSteps_2_1 = onboardingSteps_2.next(); !onboardingSteps_2_1.done; onboardingSteps_2_1 = onboardingSteps_2.next()) {
                    var onboardingStep = onboardingSteps_2_1.value;
                    if (onboardingStep === promptId) {
                        return !this.hasClicked(promptId);
                    }
                    else if (!this.hasClicked(onboardingStep)) {
                        return false;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (onboardingSteps_2_1 && !onboardingSteps_2_1.done && (_a = onboardingSteps_2.return)) _a.call(onboardingSteps_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        else {
            if (UseHistoryTypes_1.stepsRequiringOnboardingCompletedFirst.includes(promptId)) {
                if (!this.hasDismissedAnyOnboardingPrompts) {
                    try {
                        for (var onboardingSteps_3 = __values(UseHistoryTypes_1.onboardingSteps), onboardingSteps_3_1 = onboardingSteps_3.next(); !onboardingSteps_3_1.done; onboardingSteps_3_1 = onboardingSteps_3.next()) {
                            var onboardingStep = onboardingSteps_3_1.value;
                            if (!this.hasClicked(onboardingStep)) {
                                return false;
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (onboardingSteps_3_1 && !onboardingSteps_3_1.done && (_b = onboardingSteps_3.return)) _b.call(onboardingSteps_3);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            if (this.hasClicked(promptId)) {
                return false;
            }
            if (this.hasDismissed(promptId)) {
                return false;
            }
            return true;
        }
    };
    UseHistoryDataStore.prototype.viewedPrompt = function (promptId) {
        if (!this.hasViewed(promptId)) {
            var promptObject = this.getPromptObject(promptId);
            promptObject.hasViewed = true;
            this.useHistoryService.viewedPrompt(this.useHistory, promptId);
        }
    };
    UseHistoryDataStore.prototype.dismissedPrompt = function (promptId) {
        if (!this.hasDismissed(promptId)) {
            this.debounceNextPrompt();
            var promptObject = this.getPromptObject(promptId);
            promptObject.hasViewed = true;
            promptObject.hasDismissed = true;
            this.useHistoryService.dismissedPrompt(this.useHistory, promptId);
        }
    };
    UseHistoryDataStore.prototype.clickedPrompt = function (promptId) {
        if (!this.hasClicked(promptId)) {
            this.debounceNextPrompt();
            var promptObject = this.getPromptObject(promptId);
            promptObject.hasViewed = true;
            promptObject.hasClicked = true;
            this.useHistoryService.clickedPrompt(this.useHistory, promptId);
        }
    };
    UseHistoryDataStore.prototype.registerOnboardingSequence = function (sequenceName, completed) {
        if (completed === void 0) { completed = false; }
        var existingSequence = this.findRegisteredSequence(sequenceName);
        if (!existingSequence) {
            this.useHistory.onboarding.sequences.push({
                name: sequenceName,
                completed: completed,
            });
        }
    };
    UseHistoryDataStore.prototype.findRegisteredSequence = function (sequenceName) {
        return (0, lodash_1.find)(this.useHistory.onboarding.sequences, { name: sequenceName });
    };
    UseHistoryDataStore.prototype.hasCompletedOnboardingSequence = function (sequenceName) {
        var _a;
        var sequence = this.findRegisteredSequence(sequenceName);
        return (_a = sequence === null || sequence === void 0 ? void 0 : sequence.completed) !== null && _a !== void 0 ? _a : false;
    };
    UseHistoryDataStore.prototype.completeOnboardingSequence = function (sequenceName) {
        return __awaiter(this, void 0, Promise, function () {
            var sequence;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sequence = this.findRegisteredSequence(sequenceName);
                        if (sequence) {
                            sequence.completed = true;
                        }
                        else {
                            this.useHistory.onboarding.sequences.push({
                                name: sequenceName,
                                completed: true,
                            });
                        }
                        return [4, this.useHistoryService.update(this.useHistory)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    UseHistoryDataStore.prototype.viewedTemplateExplainer = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.useHistory.shownMarkTemplateExplainer = true;
                        return [4, this.useHistoryService.update(this.useHistory)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    UseHistoryDataStore.prototype.debounceNextPrompt = function () {
        var _this = this;
        this.isDebounced = true;
        setTimeout(function () {
            (0, mobx_1.runInAction)(function () {
                _this.isDebounced = false;
            });
        }, 10000);
    };
    Object.defineProperty(UseHistoryDataStore.prototype, "roiCalculatorCompletedSteps", {
        get: function () {
            return this.useHistory.usageSteps.roiCalculator;
        },
        enumerable: false,
        configurable: true
    });
    UseHistoryDataStore.prototype.shouldShowPageStateModal = function (state, subStatus) {
        return !(this.useHistory.hiddenPageStateModals.includes(state) || this.useHistory.hiddenPageStateModals.includes(subStatus));
    };
    Object.defineProperty(UseHistoryDataStore.prototype, "userEntryPoint", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.useHistory.signup) === null || _a === void 0 ? void 0 : _a.entryPoint) === null || _b === void 0 ? void 0 : _b.type;
        },
        enumerable: false,
        configurable: true
    });
    UseHistoryDataStore.prototype.hidePageStateModal = function (state) {
        this.useHistory.hiddenPageStateModals.push(state);
        this.useHistoryService.update(this.useHistory);
    };
    UseHistoryDataStore.prototype.shouldShowPageStateChangeConfirmationModal = function (state) {
        return !this.useHistory.hiddenPageStateChangeConfirmationModals.includes(state);
    };
    UseHistoryDataStore.prototype.hidePageStateChangeConfirmationModal = function (state) {
        this.useHistory.hiddenPageStateChangeConfirmationModals.push(state);
        this.useHistoryService.update(this.useHistory);
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof UseHistoryTypes_1.IUseHistory !== "undefined" && UseHistoryTypes_1.IUseHistory) === "function" ? _a : Object)
    ], UseHistoryDataStore.prototype, "useHistory", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], UseHistoryDataStore.prototype, "isDebounced", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_b = typeof InlinePromptsHistoryStore_1.default !== "undefined" && InlinePromptsHistoryStore_1.default) === "function" ? _b : Object)
    ], UseHistoryDataStore.prototype, "_inlinePromptsHistoryStore", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_c = typeof NewFeaturesIndicatorStore_1.default !== "undefined" && NewFeaturesIndicatorStore_1.default) === "function" ? _c : Object)
    ], UseHistoryDataStore.prototype, "_newFeaturesIndicator", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof InlinePromptsHistoryStore_1.default !== "undefined" && InlinePromptsHistoryStore_1.default) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "inlinePromptsHistoryStore", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof NewFeaturesIndicatorStore_1.default !== "undefined" && NewFeaturesIndicatorStore_1.default) === "function" ? _e : Object),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "newFeaturesIndicatorStore", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowAnyOnboardingPrompts", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "hasDismissedAnyOnboardingPrompts", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowEditTextPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowStylePrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowAddBlockPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowSharePrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowCommentsPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowContentLibraryPrompt", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "hasCompletedOnboarding", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "hasCompletedCensusCollector", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowTemplateExplainer", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowBlockLibraryExplainer", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UseHistoryDataStore.prototype, "shouldShowTrialConfirmationModal", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof PromptTypes_1.PromptId !== "undefined" && PromptTypes_1.PromptId) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "viewedPrompt", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_g = typeof PromptTypes_1.PromptId !== "undefined" && PromptTypes_1.PromptId) === "function" ? _g : Object]),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "dismissedPrompt", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof PromptTypes_1.PromptId !== "undefined" && PromptTypes_1.PromptId) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "clickedPrompt", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof OnboardingTypes_1.SequenceName !== "undefined" && OnboardingTypes_1.SequenceName) === "function" ? _j : Object, Object]),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "registerOnboardingSequence", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_k = typeof OnboardingTypes_1.SequenceName !== "undefined" && OnboardingTypes_1.SequenceName) === "function" ? _k : Object]),
        __metadata("design:returntype", Boolean)
    ], UseHistoryDataStore.prototype, "hasCompletedOnboardingSequence", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof OnboardingTypes_1.SequenceName !== "undefined" && OnboardingTypes_1.SequenceName) === "function" ? _l : Object]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], UseHistoryDataStore.prototype, "completeOnboardingSequence", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], UseHistoryDataStore.prototype, "viewedTemplateExplainer", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UseHistoryDataStore.prototype, "dismissBlockLibraryExplainer", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "debounceNextPrompt", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UseHistoryDataStore.prototype, "completeRoiCalculatorStep", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UseHistoryDataStore.prototype, "completeRoiCalculatorSteps", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "hidePageStateModal", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_r = typeof UseHistoryTypes_1.PageStateChangeConfirmation !== "undefined" && UseHistoryTypes_1.PageStateChangeConfirmation) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], UseHistoryDataStore.prototype, "hidePageStateChangeConfirmationModal", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UseHistoryDataStore.prototype, "silentlySkipAllPrompts", void 0);
    return UseHistoryDataStore;
}());
exports.UseHistoryDataStore = UseHistoryDataStore;
var emptyPrompt = function () {
    return {
        hasViewed: false,
        hasDismissed: false,
        hasClicked: false,
    };
};
var emptyOnboarding = function () {
    return {
        sequences: [],
    };
};
var emptyUsageSteps = function () {
    return { roiCalculator: [] };
};
exports.default = UseHistoryDataStore;
